import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '@sparknz/spark-pattern-library';
import {
  ConfigProviderProps,
  ForgotEmailJourney,
  ForgotPasswordJourney,
  RegisterJourney,
  LoginJourney as SignInJourney,
  SparkComponentLibrary,
  UniversalLoginProvider,
} from '@sparknz/universal-login-library';

import { environmentVariables } from 'shared/utils/environment.utils';

type Journey = 'forgotEmail' | 'forgotPassword' | 'register' | 'signIn';

interface JourneyProps {
  onLoginSuccess: () => void;
}

function Journey({ onLoginSuccess }: JourneyProps) {
  const [activeJourney, setActiveJourney] = useState<Journey>('signIn');

  if (activeJourney === 'forgotEmail') {
    return (
      <ForgotEmailJourney onSignInResult={() => setActiveJourney('signIn')} />
    );
  }

  if (activeJourney === 'forgotPassword') {
    return (
      <ForgotPasswordJourney
        onSignInResult={() => setActiveJourney('signIn')}
        onForgotEmailResult={() => setActiveJourney('forgotEmail')}
        onSubmitVerificationResult={() => {
          // nothing
        }}
        onForgotUserIdResult={() => {
          // nothing
        }}
      />
    );
  }

  if (activeJourney === 'signIn') {
    return (
      <SignInJourney
        onForgotPasswordResult={() => setActiveJourney('forgotPassword')}
        onLoginSuccess={onLoginSuccess}
        onRegisterResult={() => setActiveJourney('register')}
      />
    );
  }

  if (activeJourney === 'register') {
    return (
      <RegisterJourney onSignInResult={() => setActiveJourney('signIn')} />
    );
  }

  return null;
}

const ContentContainer = styled.div`
  max-width: 312px;
`;

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}

export default function LoginModal({
  onClose,
  onLoginSuccess,
  isOpen,
}: LoginModalProps) {
  const { trackingURL, apiURL, hCaptchaKey } = environmentVariables;

  const config: ConfigProviderProps = {
    apiBaseURL: apiURL,
    brand: 'Spark',
    host: '', // @TODO remove this from ULA's config
    fallbackURL: window.location.origin,
    trackingScriptURL: trackingURL,
    hCaptchaKey,
    name: '',
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} showCloseButton>
      <UniversalLoginProvider
        config={config}
        componentLibrary={SparkComponentLibrary}
      >
        <ContentContainer>
          <Journey onLoginSuccess={onLoginSuccess} />
        </ContentContainer>
      </UniversalLoginProvider>
    </Modal>
  );
}
